// Идентификация клиента.
// Демо живёт на localStorage (это ограничение демо, а не сервиса).
// Прод: анонимная клиентская сессия на D1 — сервер выдаёт httpOnly-cookie
// mnc_client, а телефон хранится рядом с токеном. /api/my-bookings отдаёт
// только записи этого клиента, никакого «показываем весь салон».
import { apiGet, demoMode } from './api';

const CLIENT_PHONE_KEY = 'mnc-client-phone';

// Нормализуем телефон: только цифры, ведущая 8 -> 7.
export function normalizePhone(input: string): string {
  const digits = input.replace(/\D/g, '');
  if (digits.length === 11 && digits.startsWith('8')) return '7' + digits.slice(1);
  if (digits.length === 10) return '7' + digits;
  return digits;
}

// Телефон текущего клиента на этом устройстве (последний, на который записались).
export function getStoredClientPhone(): string | null {
  try {
    const raw = localStorage.getItem(CLIENT_PHONE_KEY);
    return raw && raw.trim() ? raw.trim() : null;
  } catch {
    return null;
  }
}

export function setStoredClientPhone(phone: string): void {
  try {
    localStorage.setItem(CLIENT_PHONE_KEY, normalizePhone(phone));
  } catch {
    /* приватный режим */
  }
}

// Убедиться, что у клиента есть серверная сессия (cookie mnc_client).
// Без неё запись создаётся, но /api/my-bookings не сможет её найти.
export async function ensureClientSession(_phone: string): Promise<void> {
  if (demoMode) return;
  try {
    await apiGet<{ ok: boolean }>('/client-session');
  } catch {
    // Сессия не критична для самой записи — POST /api/bookings создаст её сам.
  }
}
